module.exports = __webpack_public_path__ + "static/img/img-code01.287229d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-code01.png
// module id = XrLe
// module chunks = 1